import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CMSPath } from "../../../config/constant";
import { getDefaultAnalyticsLabel, makeStringStrictlyCapitalize, toBool } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { scrollToTop } from "../../../JS/scrollToTop";

const getBookingShowType = (onlineEnabled, callToBook) =>{
  // 1. onlineEnabled = true  and  callToBook = false  ---> show online booking
  // 2. onlineEnabled = true  and  callToBook = true ---> show online booking ( currently showing offline booking but should show online booking)
  // 3. onlineEnabled = false  and  callToBook = true ---> show offline booking
  // 4. onlineEnabled = false  and  callToBook = false ---> Don't show in the list. (currently still showing as online booking)

  if( onlineEnabled === undefined  || callToBook === undefined ) return 'ONLINE';

  if( onlineEnabled && !callToBook ) return 'ONLINE';
  if( onlineEnabled && callToBook ) return 'ONLINE-OFFLINE';
  if( !onlineEnabled && callToBook ) return 'OFFLINE';
  if( !onlineEnabled && !callToBook ) return 'NOSHOW';
  
  return "";
}

const areAllServiceInDataNoShow = (data) =>{
  return data.services.every((service)=>getBookingShowType(toBool(service.onlineEnabled) , toBool(service.callToBook))=== "NOSHOW" )
}
const SpaBooking2b = (props) => {
  const { t } = props;
  let label = getDefaultAnalyticsLabel({
    appVersion: props.installedAppVersion
      ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
      : "",
  });
  let widgetSesstionId = localStorage.getItem("spaBookingSessionToken");
  const [selectedService, setSelectedService] = useState(props.selectedService);
  const [allServicesdata, setAllServiesData] = useState(props.serviceGroupData);
  const [isAllFilterSelected, setIsAllFilterSelected] = useState(true);

  const sectionRefs = useRef([]);

  const handleNext = async () => {
    console.log(selectedService, "selectedService");
    await props.next(selectedService);
  };

  useEffect(() => console.log("selectedService", selectedService), [selectedService]);

  useEffect(() => {
    scrollToTop();

    props.sendAnalytics(
      props.guestDetail,
      props.currentWidgets.widgetType,
      "Select Spa Service - Page 1",
      {
        ...label,
        layoutTab: props.currentHomePage.tabName,
        element: "widget",
        widgetSessionId: widgetSesstionId,
        spaLocationId: props.spaLocationId,
      },
      0,
      props.guestIsLoggedIn
    );
  }, []);

  return (
    <section class="widgets spa-listing">
      <div class="widget-header">
        {props.currentWidgetObj.widgetHeaderImageUrl && (
          <div class="widget-header-img">
            <img
              src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
              alt={props.currentWidgetObj.displayName}
            />
          </div>
        )}

        <div class="widget-header-title">{t(`spaBooking.heading2`)}</div>
        <div class="widget-header-subtitle">{t(`spaBooking.sub_heading2`)}</div>
      </div>

      <div class="tab-selection">
        <ul class="tabs">
          <li>
            <a
              class={isAllFilterSelected ? "tab-selected" : ""}
              onClick={() => {
                setIsAllFilterSelected(true);
                setAllServiesData(props.serviceGroupData);
              }}
            >
              All
            </a>
          </li>
          {props.serviceGroupData.map((data, index) => {
            return (
              areAllServiceInDataNoShow(data)
              ?<></>
              :<li>
                <a
                  class={
                    !isAllFilterSelected &&
                      allServicesdata &&
                      data.name == allServicesdata[0].name
                      ? "tab-selected"
                      : ""
                  }
                  onClick={() => {
                    setIsAllFilterSelected(false);
                    setAllServiesData([data]);
                  }}
                >
                  {data.name}
                </a>
              </li>
            );
          })}
        </ul>
      </div>

      <div class="row">
        <div class="col">
          <div class="detail-body stay-body">
            <form>
              {allServicesdata &&
                allServicesdata.map((data, index) => {
                  return (
                    areAllServiceInDataNoShow(data)
                    ? <></>
                    : <div
                      class="form-row"
                      ref={(ref_) => (sectionRefs.current[index] = ref_)}
                    >
                      <p class="heading">{`${makeStringStrictlyCapitalize( data.name)}`}</p>
                      <div class="form-options">
                        {data.services.map((service) => {
                          const bookingShowType = getBookingShowType(toBool(service.onlineEnabled) , toBool(service.callToBook));

                          if(bookingShowType=== "NOSHOW") {return <></>;}
                          else if(bookingShowType=== "OFFLINE") {return <label class="radio-group no-booking">
                          <div class="radio-content">
                            <p class="heading">{makeStringStrictlyCapitalize(service.name)}</p>
                            {service.description}
                            <br />
                            <strong class="spa-info">{t(`spaBooking.contact_hotel`)}</strong>
                            <div class="options">
                              <div class="duration">{`${service.duration} ${t("spaBooking.minutes")}`}</div>
                              <div class="amount">{`${props.currencyCode} ${service.price}`}<span class="spa-price-per-person 2b">{t("spaBooking.per_person")}</span></div>
                            </div>
                          </div>
                        </label>;}
                          else if(bookingShowType=== "ONLINE"){ return   <label
                            class="radio-group"
                            onClick={() => {
                              setSelectedService({
                                name: data.name,
                                service: service,
                              });
                            }}
                          >
                            <input
                              type="radio"
                              name="Times"
                              value={service.id}
                              checked={
                                selectedService &&
                                service.id == selectedService.service.id
                              }
                            />
                            <div class="radio-content">
                              <p class="heading">{makeStringStrictlyCapitalize(service.name)}</p>
                              {service.description}
                              <div class="options">
                                <div class="duration">{`${service.duration
                                  } ${t("spaBooking.minutes")}`}</div>
                                <div class="amount">{`${props.currencyCode} ${service.price}`}<span class="spa-price-per-person 2b">{t("spaBooking.per_person")}</span></div>
                              </div>
                            </div>
                          </label>}
                          else {
                            return <>
                              <label class="radio-group no-booking">
                              <div class="radio-content">
                                <p class="heading">{makeStringStrictlyCapitalize(service.name)}</p>
                                {service.description}
                                <br />
                                <strong class="spa-info">{t(`spaBooking.contact_hotel`)}</strong>
                                <div class="options">
                                  <div class="duration">{`${service.duration} ${t("spaBooking.minutes")}`}</div>
                                  <div class="amount">{`${props.currencyCode} ${service.price}`}<span class="spa-price-per-person 2b">{t("spaBooking.per_person")}</span></div>
                                </div>
                              </div>
                            </label>
                            <label
                              class="radio-group"
                              onClick={() => {
                                setSelectedService({
                                  name: data.name,
                                  service: service,
                                });
                              }}
                            >
                              <input
                                type="radio"
                                name="Times"
                                value={service.id}
                                checked={
                                  selectedService &&
                                  service.id == selectedService.service.id
                                }
                              />
                              <div class="radio-content">
                                <p class="heading">{makeStringStrictlyCapitalize(service.name)}</p>
                                {service.description}
                                <div class="options">
                                  <div class="duration">{`${service.duration
                                    } ${t("spaBooking.minutes")}`}</div>
                                  <div class="amount">{`${props.currencyCode} ${service.price}`}<span class="spa-price-per-person 2b">{t("spaBooking.per_person")}</span></div>
                                </div>
                              </div>
                            </label>
                            </>
                          }
                        
                        })}
                      </div>
                    </div>
                  );
                })}
            </form>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-controls">
          <button disabled={!selectedService} onClick={handleNext}>
            {t("spaBooking.next")}
          </button>
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => {
  return {
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currencyCode: state.store.home.clientConfig.currencyDetails
      ? state.store.home.clientConfig.currencyDetails.code
      : "",
  };
};

export default connect(mapStateToProps, { sendAnalytics })(
  withTranslation("translations")(SpaBooking2b)
);
